"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MultiTargetStrategyBuilder_1 = require("./MultiTargetStrategyBuilder");

var MultiTargetStrategyConverter_1 = require("./MultiTargetStrategyConverter");

var StrategyConverterTypeEnum_1 = require("./StrategyConverterTypeEnum");
/**
 * Default implementation of {@link MultiTargetStrategyConverter}.
 *
 * @author RV
 */


var MultiTargetStrategyConverterImpl =
/*#__PURE__*/
function (_MultiTargetStrategyC) {
  _inherits(MultiTargetStrategyConverterImpl, _MultiTargetStrategyC);

  function MultiTargetStrategyConverterImpl() {
    _classCallCheck(this, MultiTargetStrategyConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(MultiTargetStrategyConverterImpl).apply(this, arguments));
  }

  _createClass(MultiTargetStrategyConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new MultiTargetStrategyBuilder_1.MultiTargetStrategyBuilder(this.deserializeStrategyType(source, conversions), conversions.asObjectList(source, 'competitorIds', function (competitorId) {
        return conversions.toClassReferenceId(competitorId);
      })).build();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        strategyType: source.getType(),
        competitorIds: conversions.asObjectArray(source, 'competitorIds', function (competitorId) {
          return conversions.toDocumentReferenceId(competitorId);
        })
      });
      return result;
    }
  }, {
    key: "getType",
    value: function getType() {
      return StrategyConverterTypeEnum_1.StrategyConverterTypeEnum.MultiTargetStrategy;
    }
  }]);

  return MultiTargetStrategyConverterImpl;
}(MultiTargetStrategyConverter_1.MultiTargetStrategyConverter);

exports.MultiTargetStrategyConverterImpl = MultiTargetStrategyConverterImpl;